import React from "react";
import { Row, Col } from 'react-bootstrap';

import Feature1Item from './feature1-item';

function Feature1Items(props) {
    const items = props.itemsBox;
    const itemsDetails = items.map(( item, index ) =>
        // Key should be specified inside the array.
        <Col md={4} sm={6} key={ item.title.toString() }>
            <Feature1Item
                key={ item.title.toString() }
                value={ item }
                index={ index }
                />
        </Col>
    );
  
    return (
        <Row>
            { itemsDetails }
        </Row>
    );
}

export default class Feature1Row extends React.Component {
    render() {
        return (
            <Feature1Items itemsBox={ this.props.featureItems }/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/feature1-row.jsx